import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GerenciaArquivo } from 'src/app/@shared/models/gerencia-arquivo/gerencia-arquivo';
import { StorageService } from 'src/app/services/storage/storage.service';
import { environment } from 'src/environments/environment';
import { GerenciaArquivoService } from '../gerencia-arquivo.service';

@Component({
  selector: 'app-lista-gerencia-arquivo',
  templateUrl: './lista-gerencia-arquivo.component.html',
  styleUrls: ['./lista-gerencia-arquivo.component.scss']
})
export class ListaGerenciaArquivoComponent implements OnInit {
  
  isLoading: boolean = false;
  listaArquivos: GerenciaArquivo[] = [];
  public displayedColumns = ['nomeArquivo', 'usuario', 'dataUpload', 'action',]


  constructor(private gerenciaArquivoService: GerenciaArquivoService,
    public snackBar: MatSnackBar) { }

  ngOnInit(): void {

    this.carregaItens();
  }

  config = {
    disableClose: true,
    width: '50%',
    data: {
      id: 0,
      arquivoId: 0
    }
  };

  carregaItens() {
    this.isLoading = true;

    this.gerenciaArquivoService.ObterArquivosPorUsuario(StorageService.getPerfilUsuario().username).subscribe(obj => {
      this.listaArquivos = obj;
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.log(error);
    })
  }

  getUrlDownload(item: string) {
    return `${environment.api}${item}`;
  }

  openSnackBar(message: string): any {
    this.snackBar.open(message, null, { duration: 5000 });
  }

}